import React from 'react';

export const SystemSettingContext = React.createContext({});

//export const Provider = SystemSettingContext.Provider;
//export const Consumer = SystemSettingContext.Consumer;